import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-[#0c1427] rounded-xl shadow-sm border border-gray-100 dark:border-[#2a3441] overflow-hidden h-full flex flex-col" }
const _hoisted_2 = { class: "p-6 border-b border-gray-100 dark:border-[#2a3441]" }
const _hoisted_3 = { class: "flex items-start justify-between mb-4" }
const _hoisted_4 = { class: "text-lg font-semibold text-gray-800 dark:text-white" }
const _hoisted_5 = { class: "relative mb-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "space-y-3" }
const _hoisted_8 = { class: "flex w-full" }
const _hoisted_9 = { class: "flex w-full" }
const _hoisted_10 = { value: "" }
const _hoisted_11 = { value: "assigned" }
const _hoisted_12 = { value: "unassigned" }
const _hoisted_13 = { value: "my_assignments" }
const _hoisted_14 = ["label"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { value: "" }
const _hoisted_17 = { value: "1h" }
const _hoisted_18 = { value: "24h" }
const _hoisted_19 = { value: "7d" }
const _hoisted_20 = { value: "30d" }
const _hoisted_21 = { class: "bg-white dark:bg-[#0c1427] rounded-xl shadow-xl border border-gray-200 dark:border-[#2a3441] w-full max-w-md mx-4" }
const _hoisted_22 = { class: "p-6" }
const _hoisted_23 = { class: "flex items-center justify-between mb-4" }
const _hoisted_24 = { class: "text-lg font-semibold text-gray-800 dark:text-white" }
const _hoisted_25 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "flex gap-3 pt-2" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "material-symbols-outlined animate-spin !text-base"
}
const _hoisted_34 = { class: "overflow-y-auto flex-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex items-start justify-between" }
const _hoisted_37 = { class: "flex items-start gap-2 flex-1" }
const _hoisted_38 = { class: "relative" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = { class: "flex-1" }
const _hoisted_41 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_42 = { class: "font-medium text-sm text-gray-900 dark:text-white" }
const _hoisted_43 = {
  key: 0,
  class: "flex items-center gap-1",
  style: {"margin-top":"-10px"}
}
const _hoisted_44 = { class: "text-[9px] text-blue-600 dark:text-blue-400 font-medium" }
const _hoisted_45 = { class: "text-xs text-gray-600 dark:text-gray-300 truncate" }
const _hoisted_46 = { class: "text-right flex flex-col items-end gap-1" }
const _hoisted_47 = { class: "flex items-center gap-1 relative" }
const _hoisted_48 = { class: "text-xs text-gray-400 dark:text-gray-500" }
const _hoisted_49 = {
  key: 0,
  class: "min-w-[16px] h-[16px] text-[8px] font-bold rounded-full flex items-center justify-center bg-red-500 text-white absolute -bottom-1 right-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.directT('chat.messages')), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showNewChatForm = true)),
          class: "bg-primary-600 hover:bg-primary-700 text-white px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors",
          style: {"margin-top":"-0.5rem"}
        }, [
          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "material-symbols-outlined !text-base" }, "add", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.directT('chat.newChat')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
          type: "text",
          placeholder: _ctx.directT('chat.search'),
          class: "w-full pl-10 pr-4 py-2 border border-gray-200 dark:border-[#2a3441] rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 text-sm bg-white dark:bg-[#15203c] text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400"
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "material-symbols-outlined absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 !text-base" }, "search", -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.statusFilter = '')),
            class: _normalizeClass({
              'flex-1 py-1.5 text-xs rounded-lg font-medium transition-colors text-center': true,
              'bg-primary-50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-300': _ctx.statusFilter === '',
              'text-gray-500 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-[#15203c]': _ctx.statusFilter !== ''
            })
          }, _toDisplayString(_ctx.directT('chat.filters.allStatuses')), 3),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "w-px bg-gray-200 dark:bg-gray-600 my-1" }, null, -1)),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.statusFilter = 'open')),
            class: _normalizeClass({
              'flex-1 py-1.5 text-xs rounded-lg font-medium transition-colors text-center': true,
              'bg-primary-50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-300': _ctx.statusFilter === 'open',
              'text-gray-500 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-[#15203c]': _ctx.statusFilter !== 'open'
            })
          }, _toDisplayString(_ctx.directT('chat.filters.open')), 3),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "w-px bg-gray-200 dark:bg-gray-600 my-1" }, null, -1)),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.statusFilter = 'closed')),
            class: _normalizeClass({
              'flex-1 py-1.5 text-xs rounded-lg font-medium transition-colors text-center': true,
              'bg-primary-50 text-primary-600 dark:bg-primary-900/20 dark:text-primary-300': _ctx.statusFilter === 'closed',
              'text-gray-500 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-[#15203c]': _ctx.statusFilter !== 'closed'
            })
          }, _toDisplayString(_ctx.directT('chat.filters.closed')), 3)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.assignmentFilter) = $event)),
            class: "flex-1 text-xs border border-gray-200 dark:border-[#2a3441] rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-[#15203c] text-gray-900 dark:text-white appearance-none",
            style: {"background-image":"none"}
          }, [
            _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.directT('chat.filters.allAssignments')), 1),
            _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.directT('chat.filters.assigned')), 1),
            _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.directT('chat.filters.unassigned')), 1),
            _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.directT('chat.filters.assignedToMe')), 1),
            (_ctx.orgUsers && _ctx.orgUsers.length > 0)
              ? (_openBlock(), _createElementBlock("optgroup", {
                  key: 0,
                  label: _ctx.directT('chat.filters.assignedToSpecificUser')
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.orgUsers || []), (user) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: user.user_id,
                      value: `user_${user.user_id}`
                    }, _toDisplayString(user.display_name), 9, _hoisted_15))
                  }), 128))
                ], 8, _hoisted_14))
              : _createCommentVNode("", true)
          ], 512), [
            [_vModelSelect, _ctx.assignmentFilter]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.timeFilter) = $event)),
            class: "flex-1 text-xs border border-gray-200 dark:border-[#2a3441] rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-[#15203c] text-gray-900 dark:text-white appearance-none ml-2",
            style: {"background-image":"none"}
          }, [
            _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.directT('chat.filters.allTimes')), 1),
            _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.directT('chat.filters.lastHour')), 1),
            _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.directT('chat.filters.last24Hours')), 1),
            _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.directT('chat.filters.lastWeek')), 1),
            _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.directT('chat.filters.lastMonth')), 1)
          ], 512), [
            [_vModelSelect, _ctx.timeFilter]
          ])
        ])
      ])
    ]),
    (_ctx.showNewChatForm)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
          onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeNewChatForm && _ctx.closeNewChatForm(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.directT('chat.newChat')), 1),
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeNewChatForm && _ctx.closeNewChatForm(...args))),
                  class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                }, _cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "close", -1)
                ]))
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startNewChat && _ctx.startNewChat(...args)), ["prevent"])),
                class: "space-y-4"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.directT('chat.newChatForm.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newChatForm.name) = $event)),
                    type: "text",
                    placeholder: _ctx.directT('chat.newChatForm.namePlaceholder'),
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-[#2a3441] rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-[#15203c] text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400"
                  }, null, 8, _hoisted_26), [
                    [_vModelText, _ctx.newChatForm.name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.directT('chat.newChatForm.phone')) + " * ", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newChatForm.phone) = $event)),
                    type: "tel",
                    required: "",
                    placeholder: _ctx.directT('chat.newChatForm.phonePlaceholder'),
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-[#2a3441] rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-[#15203c] text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400"
                  }, null, 8, _hoisted_28), [
                    [_vModelText, _ctx.newChatForm.phone]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.directT('chat.newChatForm.message')) + " * ", 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newChatForm.message) = $event)),
                    required: "",
                    rows: "3",
                    placeholder: _ctx.directT('chat.newChatForm.messagePlaceholder'),
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-[#2a3441] rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-[#15203c] text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400 resize-none"
                  }, null, 8, _hoisted_30), [
                    [_vModelText, _ctx.newChatForm.message]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeNewChatForm && _ctx.closeNewChatForm(...args))),
                    class: "flex-1 px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-[#15203c] hover:bg-gray-200 dark:hover:bg-[#1a2332] rounded-lg transition-colors"
                  }, _toDisplayString(_ctx.directT('common.cancel')), 1),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.isStartingChat || !_ctx.newChatForm.phone || !_ctx.newChatForm.message,
                    class: "flex-1 px-4 py-2 bg-primary-600 hover:bg-primary-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors flex items-center justify-center gap-2"
                  }, [
                    (_ctx.isStartingChat)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_33, "refresh"))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.isStartingChat ? _ctx.directT('chat.newChatForm.starting') : _ctx.directT('chat.newChatForm.start')), 1)
                  ], 8, _hoisted_32)
                ])
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredChatList, (chat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["chat-item p-3 border-b border-gray-100 dark:border-[#2a3441] hover:bg-gray-50 dark:hover:bg-[#15203c] cursor-pointer transition-colors min-h-[60px]", { 'bg-primary-50 dark:bg-primary-900/20': _ctx.selectedChatId === chat.id }]),
          onClick: ($event: any) => (_ctx.selectChat(chat))
        }, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("img", {
                  src: chat.profile_picture_url || _ctx.defaultProfileImage,
                  alt: chat.name || chat.phone,
                  class: "h-8 w-8 rounded-full",
                  onError: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_39),
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute right-0 bottom-0 w-2 h-2 rounded-full border border-white dark:border-[#0c1427]", {
                  'bg-success-500': chat.status === 'online',
                  'bg-orange-400': chat.status === 'away',
                  'bg-gray-400': chat.status !== 'online' && chat.status !== 'away'
                }])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("h3", _hoisted_42, _toDisplayString(chat.name || chat.phone), 1),
                  (chat.assignedName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "material-symbols-outlined text-[10px] text-blue-500" }, "person", -1)),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(chat.assignedName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_45, _toDisplayString(chat.typing ? _ctx.directT('chat.typing') : chat.lastMessage), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("span", {
                class: _normalizeClass({
                'px-1.5 py-0.5 text-xs rounded-full': true,
                'bg-success-50 text-success-600 dark:bg-success-900/20 dark:text-success-300': _ctx.isChatOpen(chat),
                'bg-gray-50 text-gray-600 dark:bg-gray-900/20 dark:text-gray-300': !_ctx.isChatOpen(chat)
              })
              }, _toDisplayString(_ctx.isChatOpen(chat) ? _ctx.directT('chat.filters.open') : _ctx.directT('chat.filters.closed')), 3),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("p", _hoisted_48, _toDisplayString(chat.lastTime), 1),
                (chat.unread && chat.unread > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(chat.unread > 99 ? "99+" : chat.unread), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 10, _hoisted_35))
      }), 128))
    ])
  ]))
}